import { MainLayout } from '@/layouts/main-layout';

import { ProductCard } from '@/features/product-card';

import { products } from '@/entities/products/const';

import { Breadcrumbs } from '@/shared/components/breadcrumbs';
import { PageSeo } from '@/shared/lib/seo';
import { EnhancedNextPage } from '@/shared/types/enhanced-next-page';

const ProductsPage: EnhancedNextPage = () => {
  return (
    <>
      <PageSeo title="Косметика" />

      <div className="container py-6">
        <Breadcrumbs paths={[['Косметика']]} />
      </div>

      <div className="container space-y-4 pb-6">
        <h1 className="text-4xl">Косметика</h1>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
          {products.map((product) => (
            <ProductCard key={product.article} product={product} />
          ))}
        </div>
      </div>
    </>
  );
};

ProductsPage.Layout = MainLayout;

export default ProductsPage;
